import React from 'react'
import { Form, Input, InputNumber, Switch, Select } from 'antd'
import { SelectF } from '@/i2antdV5'

const FormItem = Form.Item
const { Option } = Select

// 服务类型选项
const SERVICE_TYPE_OPTIONS = [
  { id: 'maternity', value: '产康' },
  { id: 'nursing', value: '护理' },
  { id: 'home', value: '到家' }
]

class DispatchingRuleForm extends React.Component {
  componentDidMount() {
    const { form, editingRule } = this.props
    if (form && form.current && editingRule) {
      // 设置表单值
      const formValues = {
        ruleName: editingRule.ruleName,
        serviceType: editingRule.serviceType,
        radius: editingRule.radius || 5,
        enabled: editingRule.enabled !== undefined ? editingRule.enabled : true,
        includeUpcoming: editingRule.matchConditions?.includeUpcoming !== undefined 
          ? editingRule.matchConditions.includeUpcoming 
          : true,
        minRating: editingRule.matchConditions?.minRating,
        maxDistance: editingRule.matchConditions?.maxDistance,
        pushCount: editingRule.pushSettings?.pushCount || 3,
        timeout: editingRule.pushSettings?.timeout || 30
      }
      form.current.setFieldsValue(formValues)
    }
  }

  componentDidUpdate(prevProps) {
    const { form, editingRule } = this.props
    // 当编辑规则变化时，更新表单值
    if (form && form.current && editingRule && prevProps.editingRule !== editingRule) {
      const formValues = {
        ruleName: editingRule.ruleName,
        serviceType: editingRule.serviceType,
        radius: editingRule.radius || 5,
        enabled: editingRule.enabled !== undefined ? editingRule.enabled : true,
        includeUpcoming: editingRule.matchConditions?.includeUpcoming !== undefined 
          ? editingRule.matchConditions.includeUpcoming 
          : true,
        minRating: editingRule.matchConditions?.minRating,
        maxDistance: editingRule.matchConditions?.maxDistance,
        pushCount: editingRule.pushSettings?.pushCount || 3,
        timeout: editingRule.pushSettings?.timeout || 30
      }
      form.current.setFieldsValue(formValues)
    }
    // 当没有编辑规则时，重置表单
    if (form && form.current && !editingRule && prevProps.editingRule) {
      form.current.resetFields()
    }
  }

  render() {
    const { form } = this.props

    return (
      <Form
        ref={form}
        layout="vertical"
        initialValues={{
          radius: 5,
          enabled: true,
          includeUpcoming: true,
          pushCount: 3,
          timeout: 30
        }}
      >
        <FormItem
          label="规则名称"
          name="ruleName"
          rules={[{ required: true, message: '请输入规则名称' }]}
        >
          <Input placeholder="请输入规则名称" />
        </FormItem>

        <FormItem
          label="服务类型"
          name="serviceType"
          rules={[{ required: true, message: '请选择服务类型' }]}
        >
          <SelectF
            placeholder="请选择服务类型"
            options={SERVICE_TYPE_OPTIONS}
          />
        </FormItem>

        <FormItem
          label="搜索半径（公里）"
          name="radius"
          rules={[
            { required: true, message: '请输入搜索半径' },
            { type: 'number', min: 1, max: 50, message: '搜索半径范围为1-50公里' }
          ]}
        >
          <InputNumber
            placeholder="请输入搜索半径"
            min={1}
            max={50}
            style={{ width: '100%' }}
          />
        </FormItem>

        <FormItem
          label="匹配条件"
          style={{ marginBottom: 0 }}
        >
          <FormItem
            name="includeUpcoming"
            valuePropName="checked"
            style={{ display: 'inline-block', marginRight: 16 }}
          >
            <Switch checkedChildren="包含即将空闲" unCheckedChildren="不包含即将空闲" />
          </FormItem>
        </FormItem>

        <FormItem
          label="最低评分要求"
          name="minRating"
          rules={[
            { type: 'number', min: 0, max: 5, message: '评分范围为0-5分' }
          ]}
        >
          <InputNumber
            placeholder="请输入最低评分（可选）"
            min={0}
            max={5}
            step={0.1}
            style={{ width: '100%' }}
          />
        </FormItem>

        <FormItem
          label="最大距离（公里）"
          name="maxDistance"
          rules={[
            { type: 'number', min: 1, max: 50, message: '最大距离范围为1-50公里' }
          ]}
        >
          <InputNumber
            placeholder="请输入最大距离（可选）"
            min={1}
            max={50}
            style={{ width: '100%' }}
          />
        </FormItem>

        <FormItem
          label="推送设置"
          style={{ marginBottom: 0 }}
        >
          <div style={{ marginBottom: 16 }}>
            <FormItem
              label="同时推送数量"
              name="pushCount"
              rules={[
                { required: true, message: '请输入推送数量' },
                { type: 'number', min: 1, max: 10, message: '推送数量范围为1-10个' }
              ]}
              style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginRight: 16 }}
            >
              <InputNumber
                placeholder="推送数量"
                min={1}
                max={10}
                style={{ width: '100%' }}
              />
            </FormItem>
            <FormItem
              label="接单超时时间（分钟）"
              name="timeout"
              rules={[
                { required: true, message: '请输入超时时间' },
                { type: 'number', min: 1, max: 120, message: '超时时间范围为1-120分钟' }
              ]}
              style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
            >
              <InputNumber
                placeholder="超时时间"
                min={1}
                max={120}
                style={{ width: '100%' }}
              />
            </FormItem>
          </div>
        </FormItem>

        <FormItem
          label="启用状态"
          name="enabled"
          valuePropName="checked"
        >
          <Switch checkedChildren="启用" unCheckedChildren="禁用" />
        </FormItem>
      </Form>
    )
  }
}

export default DispatchingRuleForm

